import React from "react";
import { Link } from "react-router-dom";
import { FaChevronRight } from "react-icons/fa";

/**
 * Shared breadcrumb trail. Always starts at Home.
 * items: [{ label, to? }] — last item without `to` renders as current page.
 */
const Breadcrumb = ({ items = [], className = "" }) => {
  return (
    <nav
      className={`flex flex-wrap items-center gap-1.5 text-xs text-gray-400 ${className}`}
      aria-label="Breadcrumb"
    >
      <Link to="/" className="hover:text-designer-primary transition-colors">
        Home
      </Link>
      {items.map((item) => (
        <React.Fragment key={item.label}>
          <FaChevronRight aria-hidden="true" className="w-2 h-2 shrink-0" />
          {item.to ? (
            <Link to={item.to} className="hover:text-designer-primary transition-colors">
              {item.label}
            </Link>
          ) : (
            <span className="text-gray-500 font-medium" aria-current="page">
              {item.label}
            </span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumb;
